import React, { FunctionComponent, useEffect, useState } from 'react'
import { Table, Typography, Col, Row, notification, Space } from 'antd'
import { FilterValue, SorterResult, TablePaginationConfig } from 'antd/lib/table/interface'

import { columns } from './columns'

import { DEFAULT_PAGE_SIZE } from '../../../../constants'
import { getInvitesList } from '../../../../context/admin/utils'
import { Invite } from '../../../../context/types'

const { Title } = Typography

interface AdminUsersProps {
	state?: number
	forceUpdate?: () => void
}

const AdminInvites: FunctionComponent<AdminUsersProps> = (props) => {
	const { state } = props

	const [loading, setLoading] = useState(false)

	const [page, setPage] = useState(1)

	const [total, setTotal] = useState(10)
	const [invites, setInvites] = useState<Invite[]>([])

	useEffect(() => {
		setLoading(true)
		getInvitesList((page - 1) * DEFAULT_PAGE_SIZE, DEFAULT_PAGE_SIZE)
			.then((r) => {
				setInvites(r.invites)
				setTotal(r.total)
			})
			.catch(handleError)
			.finally(() => setLoading(false))
	}, [page, state])

	const handleError = (err: any) => {
		notification.error({ message: err.message || 'Server error' })
	}

	const onChange: OnChange = (pagination) => {
		setPage(pagination.current)
	}

	return (
		<Space direction="vertical" style={{ maxWidth: '100%' }}>
			<Row>
				<Col span={24}>
					<Title level={3}>Invites</Title>
				</Col>
			</Row>
			<Table
				rowKey={'invite_id'}
				columns={columns}
				dataSource={invites}
				pagination={{ pageSize: DEFAULT_PAGE_SIZE, current: page, total }}
				loading={loading}
				onChange={onChange}
				scroll={{ x: true }}
			/>
		</Space>
	)
}

export default AdminInvites

type OnChange = (
	pagination: TablePaginationConfig,
	filters: Record<string, FilterValue | null>,
	sorter: SorterResult<any> | SorterResult<any>[]
) => void
